/*
 * Copyright (c) 2018 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { Injectable } from '@angular/core';

import { DataQuery } from '@typescript-kit/data';
import { HttpService } from '@angular-kit/core';

import { Employee, EmployeeData } from '@teamworks/global';

@Injectable()
export class EmployeeService {

  constructor(private httpService: HttpService) {
  }

  async loadEmployeeList(dataQuery?: DataQuery): Promise<Employee[]> {
    return this.httpService.get(`api/base-data/employee-list`, { 'data-query': dataQuery })
      .then((loadedData: EmployeeData[]) => loadedData.map(data => new Employee(data)));
  }

  async loadEmployeeListByMonth(year: string, month: string, dataQuery?: DataQuery): Promise<Employee[]> {
    return this.httpService.get(`api/base-data/employee-list/${year}/${month}`, { 'data-query': dataQuery })
      .then((loadedData: EmployeeData[]) => loadedData.map(data => new Employee(data)));
  }

  async loadEmployee(id: string, dataQuery?: DataQuery): Promise<Employee> {
    return this.httpService.get(`api/base-data/employee/${id}`, { 'data-query': dataQuery })
      .then((loadedData: EmployeeData) => loadedData && new Employee(loadedData));
  }

  async saveEmployee(data: EmployeeData): Promise<Employee> {
    return this.httpService.post(`api/base-data/employee`, data)
      .then((savedData: EmployeeData) => new Employee(savedData));
  }

  async deleteEmployee(id: string): Promise<Employee> {
    return this.httpService.delete(`api/base-data/employee/${id}`)
      .then((deletedData: EmployeeData) => new Employee(deletedData));
  }
}
